import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { AppBar, Box, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Icon, IconButton, Stack, TextField, Toolbar, Typography } from "@mui/material"
import customStyles from "app/shared-components/SelectCustomStyle";
import moment from "moment";
import { useEffect, useState } from "react";
import Select from "react-select";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useContext } from "react";
import { handleSuccessMsg } from "./OkrPerformance";
import CustomDatePicker from "../utilities/CustomDatePicker";

const AddOKRPopup = (props) => {
    const [addOpen, setAddOpen] = useState(props.open || false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [quarterName, setQuarterName] = useState();
    const [year, setYear] = useState();
    const [yearList, setYearList] = useState();
    const [customStartDate, setCustomStartDate] = useState('');
    const [customEndDate, setCustomEndDate] = useState('');
    const [updateStartDate, setUpdateStartDate] = useState('');
    const [weekDuration, setWeekDuration] = useState(3);
    const [durationList, setDurationList] = useState([]);
    const [customQuarterName, setCustomQuarterName] = useState();
    const [selectedEmail, setselectedEmail] = useState(props.selectedEmail);
    const [successMsg, setSuccessMsg] = useContext(handleSuccessMsg)

    const [quarterList, setQuarterList] = useState([
        { label: "Q1", value: 'Q1' },
        { label: "Q2", value: 'Q2' },
        { label: "Q3", value: 'Q3' },
        { label: "Q4", value: 'Q4' },
        { label: "HY1", value: 'HY1' },
        { label: "HY2", value: 'HY2' },
        { label: "Year", value: 'Year' },
    ]);
    const okrurl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.performance}`;
    const hrurl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.variableQuarter}`;

    useEffect(() => {
        if (props.open) {
            setAddOpen(props.open)
        }
    }, [props.open]);

    useEffect(() => {

        const cyear = (new Date()).getFullYear();
        let years = Array.from(new Array(20), (val, index) => { return { label: cyear - index, value: cyear - index } });
        years = [{ label: cyear + 1, value: cyear + 1 }, ...years]
        setYear(cyear);
        setYearList(years);

        const duration = 1;
        let lists = Array.from(new Array(10), (val, index) => { return { label: duration + index, value: duration + index } });
        setDurationList(lists);
    }, [])

    useEffect(() => {
        const listQuarter = [
            { label: "Q1", value: 'Q1' },
            { label: "Q2", value: 'Q2' },
            { label: "Q3", value: 'Q3' },
            { label: "Q4", value: 'Q4' },
            { label: "HY1", value: 'HY1' },
            { label: "HY2", value: 'HY2' },
            { label: "Year", value: 'Year' },
        ];

        if (year) {
            const currentDate = new Date();
            const quarters = listQuarter.filter((q) => {
                if (q.label === 'Q1') {
                    const sdate = new Date(`${year}-01-01`);
                    if (currentDate > sdate) {
                    } else {
                        return q;
                    }
                } else if (q.label === 'Q2') {
                    const sdate = new Date(`${year}-04-01`);
                    if (currentDate > sdate) {
                    } else {
                        return q;
                    }
                } else if (q.label === 'Q3') {
                    const sdate = new Date(`${year}-07-01`);
                    if (currentDate > sdate) {
                    } else {
                        return q;
                    }
                } else if (q.label === 'Q4') {

                    const sdate = new Date(`${year}-10-01`);
                    if (currentDate > sdate) {
                    } else {
                        return q;
                    }
                } else if (q.label === 'HY1') {
                    const sdate = new Date(`${year}-01-01`);
                    if (currentDate > sdate) {
                    } else {
                        return q;
                    }
                } else if (q.label === 'HY2') {
                    const sdate = new Date(`${year}-07-01`);
                    if (currentDate > sdate) {
                    } else {
                        return q;
                    }
                } else if (q.label === 'Year') {
                    const sdate = new Date(`${year}-01-01`);
                    if (currentDate > sdate) {
                    } else {
                        return q;
                    }
                }

            })
            setQuarterList(quarters)
        }
    }, [year])

    const handleOKRSubmit = async () => {
        try {
            let startingDate = '';
            let endingDate = '';
            let quarterlyName = '';
            let years = year;
            if (quarterName) {
                quarterlyName = quarterName;
                startingDate = startDate;
                endingDate = endDate;
            } else {
                quarterlyName = customQuarterName;
                startingDate = customStartDate;
                endingDate = customEndDate;
                years = (new Date(customStartDate)).getFullYear();

                await OAuthService.addData(hrurl, { name: customQuarterName })
            }
            const object = {

                quarterStartDate: startingDate,
                startDate: updateStartDate || startingDate,
                year: years,
                endDate: endingDate,
                quarterly: quarterlyName,
                weekDuration: weekDuration,
                employeeEmail: selectedEmail,
                objective: []
            }
            const list = await OAuthService.addData(okrurl + '/okrSubmit', object)
            if (list?.data) {
                setSuccessMsg("OKR Created Successfully")
            }
        } catch (error) {

        }
        setAddOpen(false)
    }
    const handleQuarterChange = (data) => {
        setQuarterName(data.value);
        setCustomEndDate('');
        setCustomStartDate('');
        setCustomQuarterName('');
        switch (data.value) {
            case 'Q1':
                setStartDate(`${year}-01-01`);
                setEndDate(`${year}-03-31`);
                return true;
            case 'Q2':
                setStartDate(`${year}-04-01`);
                setEndDate(`${year}-06-30`);
                return true;
            case 'Q3':
                setStartDate(`${year}-07-01`);
                setEndDate(`${year}-09-30`);
                return true;
            case 'Q4':
                setStartDate(`${year}-10-01`);
                setEndDate(`${year}-12-31`);
                return true;
            case 'HY1':
                setStartDate(`${year}-01-01`);
                setEndDate(`${year}-06-30`);
                return true;
            case 'HY2':
                setStartDate(`${year}-07-01`);
                setEndDate(`${year}-12-31`);
                return true;
            case 'Year':
                setStartDate(`${year}-01-01`);
                setEndDate(`${year}-12-31`);
                return true;
            default:
                return true;
        };
    }

    const handleYearChange = (data) => {
        setYear(data.value);
        setCustomEndDate('');
        setCustomStartDate('');
        setCustomQuarterName('');
        setQuarterName('')
        setStartDate('');
        setEndDate('');
    }

    return (
        <Dialog
            open={addOpen}
            fullWidth
            maxWidth={'md'}
        >
            <AppBar position="static">
                <Toolbar className="flex w-full justify-between">
                    <Typography variant="subtitle1" color="inherit">
                        Add OKR
                    </Typography>
                    <IconButton onClick={() => setAddOpen(false)}>
                        <Icon>close</Icon>
                    </IconButton>
                </Toolbar>
            </AppBar>
            <DialogContent>
                <Grid>
                    <Grid container spacing={2} className="h-[inherit]">
                        <Grid item xs={2} className="self-center">
                            <label>Select Year</label>
                        </Grid>
                        <Grid item xs={3}>
                            <Select
                                name="year"
                                value={(year && yearList) && yearList.filter((q) => q.value === year)}
                                options={yearList}
                                onChange={handleYearChange}
                                styles={customStyles()}
                            ></Select>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} className="h-[inherit] mt-0">
                        <Grid item xs={2} className="self-center">
                            <label>Select Period</label>
                        </Grid>
                        <Grid item xs={3}>
                            <Select
                                name="quarter"
                                value={(quarterName && quarterList) && quarterList.filter((q) => q.value === quarterName)}
                                options={quarterList}
                                onChange={handleQuarterChange}
                                styles={customStyles()}
                                isOptionDisabled={(option) => option.isDisabled}
                            ></Select>
                        </Grid>
                        <Grid item xs={6} className="self-center">
                            <Typography>{(startDate && endDate) && 'Start: ' + startDate + ' - End: ' + endDate}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid className="self-center p-10">
                    <Typography>----------OR Select Custom---------</Typography>
                </Grid>
                <Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={2} className="self-center">
                            <label>Select Date range</label>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack>
                                <TextField
                                    className="mb-16"
                                    type="date"
                                    value={customStartDate}
                                    name="customStartDate"
                                    onChange={(e) => {
                                        setCustomStartDate(moment(e.target.value).format('YYYY-MM-DD'))
                                        setCustomEndDate('')
                                        setStartDate('');
                                        setEndDate('');
                                        setQuarterName('');
                                        setYear('');
                                    }}
                                    variant="outlined"
                                    inputProps={{ min: moment(new Date()).format('YYYY-MM-DD') }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    sx={{ svg: 'red', input: 'red' }}

                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={1} className="text-center self-center">
                            <Typography> - </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack>
                                <TextField
                                    className="mb-16"
                                    type="date"
                                    value={customEndDate}
                                    name="customEndDate"
                                    onChange={(e) => {
                                        setCustomEndDate(moment(e.target.value).format('YYYY-MM-DD'))
                                        setStartDate('');
                                        setEndDate('');
                                        setQuarterName('');
                                        setYear('');
                                    }}
                                    variant="outlined"
                                    inputProps={{ min: customStartDate || moment(new Date()).format('YYYY-MM-DD') }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    sx={{ svg: 'red', input: 'red' }}

                                />
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid container className="pt-10" spacing={2}>
                        <Grid item xs={2} className="self-center">
                            <label>Period Name</label>
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                name={'quarterName'}
                                value={customQuarterName}
                                onChange={(event) => {
                                    setCustomQuarterName(event.target.value)
                                    setStartDate('');
                                    setEndDate('');
                                    setQuarterName('');
                                    setYear('');
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid className="pt-10">
                        Select Notification Duration for Employee's Update
                    </Grid>
                    <Grid container spacing={2} className="h-[inherit] mt-0">
                        <Grid item xs={2} className="self-center">
                            <label>Select Week Duration</label>
                        </Grid>
                        <Grid item xs={3}>
                            <Select
                                name="weekDuration"
                                value={(weekDuration && durationList) && durationList.filter((q) => q.value === weekDuration)}
                                options={durationList}
                                onChange={(data) => setWeekDuration(data.value)}
                                styles={customStyles()}
                            ></Select>
                        </Grid>
                        <Grid item xs={2} className="self-center">
                            <label>Select Update Start Date</label>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack>
                                <TextField
                                    className="mb-16"
                                    type="date"
                                    value={updateStartDate || customStartDate || startDate}
                                    name="startDate"
                                    onChange={(e) => setUpdateStartDate(moment(e.target.value || '').format('YYYY-MM-DD'))}
                                    variant="outlined"
                                    inputProps={{ min: customStartDate || startDate, max: customEndDate || endDate }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    sx={{ svg: 'red', input: 'red' }}

                                />
                            </Stack>
                        </Grid>
                    </Grid>
                </Grid>

            </DialogContent>
            <DialogActions
                sx={{ background: "#373c42" }}
            >
                <Button
                    variant="contained"
                    color="warning"
                    onClick={handleOKRSubmit}
                    disabled={(startDate && endDate && quarterName) || (customEndDate && customQuarterName && customStartDate) ? false : true}
                >
                    <Icon>save</Icon>
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddOKRPopup